import React, { Component } from "react";
import { Button } from "@culturehq/components";

import { t, Trans } from "app/utils";

import CircleCheck from "components/display/CircleCheck";
import LazyEditor from "components/editor/LazyEditor";

class CommentForm extends Component {
  editorKey = 1;

  editorRef = React.createRef();

  state = { uploading: false };

  state = { isDisable: true };

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleChange = value => {
    const jsonValue = JSON.parse(value);
    const extractedText = jsonValue.blocks.map(block => block.text).join("");
    this.setState({ isDisable: extractedText === "" });
  }

  handleSubmit = async event => {
    event.preventDefault();

    const { onSubmit } = this.props;

    this.setState({ uploading: true });

    const body = await this.editorRef.current.serialize();
    this.editorKey += 1;

    onSubmit({ body });

    if (this.componentIsMounted) {
      this.setState({ uploading: false });
      this.setState({ isDisable: true });
    }
  };

  render() {
    const { success } = this.props;
    const { uploading } = this.state;
    const { isDisable } = this.state;

    return (
      <form className="comment-form" onSubmit={this.handleSubmit}>
        <LazyEditor
          onChange={this.handleChange}
          key={this.editorKey}
          ref={this.editorRef}
          placeholder={t("Add a comment...")}
        />
        <Button disabled={isDisable} type="submit">
          {
            (success || uploading)
              ? <><CircleCheck animate background="green" /> {success}</>
              : <Trans>Post</Trans>
          }
        </Button>
      </form>
    );
  }
}

export default CommentForm;
